// src/App.js
import React, { Suspense } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { motion, AnimatePresence } from "framer-motion";
import "./App.css";
import Navbar from "./components/Navbar";
import LoadingSpinner from "./components/LoadingSpinner";
import { profileData } from "./Data/ProfileData";

// Lazy load components for code splitting
const Profile = React.lazy(() => import("./components/Profile"));
const About = React.lazy(() => import("./components/About"));
const Awards = React.lazy(() => import("./components/Awards"));
const Contact = React.lazy(() => import("./components/Contact"));
const Projects = React.lazy(() => import("./components/Projects"));
const Experience = React.lazy(() => import("./components/Experience"));
const Skills = React.lazy(() => import("./components/Skills"));

// Page transition variants
const pageVariants = {
  initial: {
    opacity: 0,
    y: 20,
    scale: 0.98
  },
  animate: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.6,
      ease: "easeOut"
    }
  },
  exit: {
    opacity: 0,
    y: -20,
    scale: 0.98,
    transition: {
      duration: 0.4,
      ease: "easeIn"
    }
  }
};

// Animated Routes Component
function AnimatedRoutes() {
  const location = useLocation();
  const contact = {
    location: "Kamloops, British Columbia, Canada",
    linkedin: "https://www.linkedin.com/in/kulrajbir-singh-sandhu-a27b57191/",
    github: "https://github.com/KulrajbirS",
    email: "kulrajsandhuu@gmail.com",
    phone: "+12502997205",
  };

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        variants={pageVariants}
        initial="initial"
        animate="animate"
        exit="exit"
      >
        <Suspense fallback={<LoadingSpinner />}>
          <Routes location={location}>
            <Route
              path="/"
              element={<Profile profile={profileData} />}
              index
            />
            <Route path="/about" element={<About />} />
            <Route path="/awards" element={<Awards />} />
            <Route path="/contact" element={<Contact contact={contact} />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/experience" element={<Experience />} />
            <Route path="/skills" element={<Skills />} />
          </Routes>
        </Suspense>
      </motion.div>
    </AnimatePresence>
  );
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="app-container">
          <Navbar />
          <div className="main-content">
            <AnimatedRoutes />
          </div>
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
